"use client";

import type { FC, ReactNode } from "react";
import { useRef } from "react";

import { useFadeInAnimation } from "@/hooks/use-fade-in-animation";

type Base404Props = {
  children: ReactNode;
  className?: string;
};

/**
 * Base 404 component providing consistent layout, animations, and styling
 * for all error page scenarios in WillPower Store
 */
const Base404: FC<Base404Props> = ({ children, className = "" }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const contentRef = useFadeInAnimation<HTMLDivElement>({
    triggerRef: containerRef,
    animateChildren: true,
    visibilityThreshold: 0.1,
    animationProps: {
      duration: 0.8,
      stagger: 0.1,
      y: 30,
      ease: "power2.out",
    },
  });

  return (
    <div
      className={`min-h-screen bg-background ${className}`}
      ref={containerRef}
    >
      <section className="overflow-hidden py-16 sm:py-20 lg:py-24">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="mx-auto max-w-4xl text-center" ref={contentRef}>
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Base404;
